<script>
import { infoDetailsMethods, infoDetailsComputed } from '@state/helpers'

export default {
  computed: {
    ...infoDetailsComputed,
  },

  methods: {
    ...infoDetailsMethods,
  },
}
</script>

<template>
  <div>
    <BaseInfoSideDetailsDeviceState
      v-if="selectedDetailsDevice && selectedDefaultObject"
      :device-event-current="selectedDefaultObject"
    />

    <BaseInfoSideDetailsDeviceStateHistory
      v-if="selectedDetailsDeviceStateHistory && selectedDefaultObject"
      :device-state-history="selectedDefaultObject"
    />

    <BaseInfoSideDetailsDeviceStateHistoryDetail
      v-if="selectedDetailsDeviceStateHistoryDetail && selectedDefaultObject"
      :device-event-current="selectedDefaultObject"
    />

    <BaseInfoSideDetailsDeviceStateHistoryDetailCondition
      v-if="selectedDetailsDeviceStateHistoryDetailCondition && selectedDefaultObject"
      :device-condition="selectedDefaultObject"
    />

    <BaseInfoSideDetailsAction
      v-if="selectedDetailsAction && selectedDefaultObject"
      :action="selectedDefaultObject"
    />

    <BaseInfoSideDetailsInteractCycle
      v-if="selectedDetailsInteractCycle && selectedDefaultObject"
      :device-event-current="selectedDefaultObject"
    />

    <BaseInfoSideDetailsInteractActivity
      v-if="selectedDetailsInteractActivity && selectedDefaultObject"
      :device-event-current="selectedDefaultObject"
    />

    <BaseInfoSideDetailsInteractActivityHistorical
      v-if="selectedDetailsInteractActivityHistorical && selectedDefaultObject"
      :changed-activity-events="selectedDefaultObject"
    />

    <BaseInfoSideDetailsInsights
      v-if="selectedDetailsInsight && selectedDefaultObject"
      :insight-lists="selectedDefaultObject"
    />
  </div>
</template>

<style lang="scss"></style>
